import service from './service.js'

export default {
    cleanHtml(html){
        return html.split('&nbsp;').join(' ');
    },
    getAvatarUrl(codFisc){
        return service.getBaseUrl() + 'utente/' + codFisc + '/immagine?nocache=' + Math.random();
    },
    formatDate(d) {
        return ("0" + d.getDate()).slice(-2) + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" +
            d.getFullYear() + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
    },
    getCookie(cName) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${cName}=`);
        if (parts.length === 2) 
            return parts.pop().split(';').shift();
        return "";
    },
    setCookie(cName, cValue, expDays) {
        var d = new Date();
        d.setTime(d.getTime() + (expDays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cName + "=" + cValue + ";" + expires + ";path=/";
    }
  }


// WEBPACK FOOTER //
// ./src/services/utils.js